<template>
  <div class="header">
    <div class="logo" v-if="isLogin">

      <router-link :to="{ name: 'contest' }"><img src="@/assets/imgs/logo.png" alt /></router-link>
    </div>
    <div class="logo" v-if="!isLogin">

      <router-link :to="{ name: 'contest' }"><img src="@/assets/imgs/logo.png" alt /></router-link>
    </div>

    <el-menu :default-active="activeIndex" class="menu" mode="horizontal" v-if="isLogin">
      <!-- <router-link tag="el-menu-item" :to="{ name: 'contest' }" index="1"
        >回到首页</router-link
      > -->
      <el-menu-item index="2" @click.native="toMessageCenter">
        <i class="el-icon-message"></i>
        消息中心
        <el-badge class="mark" :value="unReadCount" v-if="unReadCount" />
        </el-menu-item>
      <el-submenu index="3">
        <template slot="title">
          <el-avatar :src="require('../../assets/imgs/avatar.png')"></el-avatar>
          {{ $store.getters.user.nickname }}
        </template>
        <router-link tag="el-menu-item" :to="{ name: 'index' }" index="1">回到首页</router-link>
        <el-menu-item index="3-1" @click.native="toPersonal">账号设置</el-menu-item>
        <el-menu-item index="3-1" @click="signOut">退出</el-menu-item>
      </el-submenu>
      <!-- <el-menu-item index="4">
        {{ $store.getters.user.nickname }}
      </el-menu-item> -->
    </el-menu>
    <el-menu :default-active="activeIndex" class="menu" mode="horizontal" v-if="!isLogin">
      <!-- <router-link tag="el-menu-item" :to="{ name: 'contest' }" index="1"
        >比赛</router-link
      > -->
      <router-link tag="el-menu-item" :to="{ name: 'login',params:{type:'login'} }" index="1">登录</router-link>
      <router-link tag="el-menu-item" :to="{ name: 'login',params:{type:'register'} }" index="2">注册</router-link>
    </el-menu>
  </div>
</template>

<script>
import { getToken, removeToken } from "@/utils/auth";
import { logout, toPersonal } from "@/api/user";
import { baseUrl } from "@/utils/constant"
import { mapGetters } from "vuex"
export default {
  props: {
    title: "",
    subtitle: ""
  },
  data() {
    return {
      isLogin: false,
      activeIndex: "1",
      isLogin: false
    };
  },
  computed:{
    ...mapGetters([
      'unReadCount'
    ])
  },
  // inject: ['reload'],
  created() {
    this.isLogin = getToken() ? true : false;
  },
  methods: {
    signOut() {
      logout().then(res => {
        window.location = res.data;

      });
    },
    toMessageCenter() {
      window.open(baseUrl.UC_BASE_URL + '/personal/notification/list','_blank')
    },
    toPersonal(){
      const params = {
        redirect_uri: window.location.href
      }
      toPersonal(params).then(res=>{
        window.open(res.data,'_blank')
      })
    },
  }
};
</script>

<style scoped>
a:hover {
  color: #000;
}
.logo {
  width: 250px;
  height: 100%;
  text-align: center;
  line-height: 60px;
  font-size: 20px;
  float: left;
}
.logo img {
  max-width: 210px;
  max-height: 50px;
  margin-right: 10px;
  vertical-align: middle;
}
.header {
  z-index: 1000;
  /* height: 60px; */
}
.header >>> .el-menu {
  border-bottom: 2px solid rgb(121, 187, 255);
  box-sizing: unset;
}
.el-menu.el-menu--horizontal {
  border: none;
}

.el-menu {
  float: right;
  /* width: 500px; */
}
.mark{
  position: absolute;
  top: -10px;
  right: 0;
}
</style>
